import React, { Component, Fragment } from 'react'
import styled from 'styled-components'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { AppState, Dispatch } from 'store/types'
import { Table } from 'components/UI/CompactTable'
import { Modal } from 'components/UI/Modal'
import { Search } from 'components/UI/Search'
import {
    fetchServiceAreas,
    fetchAllCpt4Codes,
    // fetchCpt4Codes,
    // createCpt4,
    // updateCpt4,
    // deleteCpt4
  } from 'ducks/references/operations'
import { 
    fetchMostActiveCpt4,
    createMostActiveCpt4,
    updateMostActiveCpt4,
    deleteMostActiveCpt4
 } from 'ducks/mostActiveCpt4/operations'
import { DotsButton, DropdownList } from 'components/common'
import DropMenu from 'components/UI/DropMenu'
import { MenuOption } from 'components/common/DropdownList'
import { ContentBlock } from 'components/common'
import Pagination from '../../components/UI/Pagination'
import { history, routePath } from '../../routes'
import { Container } from 'styled-bootstrap-grid'
import Button from 'components/UI/Button'
import TextInput from 'components/UI/TextInput'
import CPT4Form from 'components/management/CPT4Form'
import { handleErrorMessageAlert } from 'components/UI/Alert'
import CheckBox from 'components/UI/CheckBox'
import { Checkbox } from 'components/UI/Switch/styles'
import { CheckIcon, CrossIcon } from 'components/icons'
import CheckCircleIcon from 'components/icons/CheckCircleIcon'
import CrossCircleIcon from 'components/icons/CrossCircleIcon'
import MostActiveCPT4Form from 'components/management/MostActiveCPT4Form'
import { MostActiveCpt4 } from 'ducks/mostActiveCpt4/types'

const headers = {  // CPT Code, CPT4 Description, ContactGroup, ServiceAreaID, ServiceAreaDescription, manual
  columns: [
      { name: 'CPT4 Code' },
      { name: 'CPT4 Description' },
      { name: 'Contact Group' },
      { name: 'Service Area ID' },
      { name: 'Service Area Description' },
      { name: 'Manual' },
    ] // { name: 'Phone' } { name: 'Member ID' }
}


class MostActiveCPT4Page extends Component<Props, MostActiveCPT4PageState> {
  constructor(props: Props) {
    super(props)

    this.state = {
      filtered: [],
      actualPage: 0,
      actualPages: [],
      pageNumbers: [],
      chunks: [],
      searchText: '',
      showConfirmDeleteModal: false,
      showCreateModal: false,
    }
  }

  componentDidMount(): void {
    this.props.fetchMostActiveCpt4(9, 0)
    this.setState({ filtered: this.props.mostActiveCpt4 })
  }
  componentDidUpdate(prevProps: any) {
    const { mostActiveCpt4 = [], loadedPageNumber = 0 } = this.props
    console.log(prevProps.mostActiveCpt4, mostActiveCpt4)
    if (
      prevProps.loadedPageNumber !== loadedPageNumber ||
      prevProps.mostActiveCpt4.length !== mostActiveCpt4.length ||
      JSON.stringify(prevProps.mostActiveCpt4) !== JSON.stringify(mostActiveCpt4)
    ) {
      this.setState({ filtered: mostActiveCpt4 })
    }
  }

  noItems = () => (
    <TextBlock>
      <p>There are no any CPT4 yet.</p>
    </TextBlock>
  )
  onSearch = (text: string) => {
    const { chunks, actualPage } = this.state
    this.setState({ searchText: text });

    // const value = text.toLowerCase()
    // const filter = patients.filter(
    //   (item: { firstName: string; lastName: string }) => {
    //     return `${item.firstName + ' ' + item.lastName}`
    //       .toLowerCase()
    //       .includes(value)
    //   }
    // )
    if (!text) {
      // this.setState({
      //   filtered: this.props.patients
      // })
      this.props.fetchMostActiveCpt4(9, 0)
      return
    }
    // this.setState({
    //   filtered: filter
    // })
    // this.props.fetchPatients(NaN, NaN, text)
    this.props.fetchMostActiveCpt4(9, 0, text)
  }
  onPageChanged = (actualPage: number) => {
    const { searchText } = this.state

    this.setState({ actualPage })
    this.props.fetchMostActiveCpt4(9, actualPage, searchText)
  }

  // chunk(array: any[], size: number) {
  //   const chunkedArr = []
  //   // tslint:disable-next-line:prefer-for-of
  //   for (let i = 0; i < array.length; i++) {
  //     const last = chunkedArr[chunkedArr.length - 1]
  //     if (!last || last.length === size) {
  //       chunkedArr.push([array[i]])
  //     } else {
  //       last.push(array[i])
  //     }
  //   }
  //   return chunkedArr
  // }
  // getPaginationData = (data: any[]) => {
  //   const chunks = this.chunk(data, 9)
  //   const pageNumbers = Object.keys(chunks)
  //   this.setState({ pageNumbers, chunks, filtered: data.slice(0, 9) })
  // }
  onHandleClear = () => {
    this.setState({
    //   filtered: ,
      searchText: ''
    })
    this.props.fetchMostActiveCpt4(9, 0)
  }

  handleFormSubmit = async (form: any) => {
      const { selectedCpt4, searchText, actualPage } = this.state
      const { createMostActiveCpt4, updateMostActiveCpt4, fetchMostActiveCpt4 } = this.props
    //   const { creatingError, updatingError } = errors
      if (selectedCpt4) {
            form.id = selectedCpt4.id;
            await updateMostActiveCpt4(form);
            !this.props.errors.updatingError && this.closeModal('showCreateModal')
    } else {
            await createMostActiveCpt4(form);
            !this.props.errors.creatingError && this.closeModal('showCreateModal')
      }
      fetchMostActiveCpt4(9, actualPage, searchText)

  }

  handleDelete = async () => {
    const { selectedCpt4, actualPage, searchText } = this.state
    const { deleteMostActiveCpt4 } = this.props
    if (selectedCpt4) {
        await deleteMostActiveCpt4(selectedCpt4.id)
    }
    // this.setState({ selectedCpt4: undefined })
    this.closeModal('showConfirmDeleteModal')
    fetchMostActiveCpt4(9, actualPage, searchText)
  }

  openModal = (modalName: 'showConfirmDeleteModal' | 'showCreateModal') => this.setState({ [modalName]: true })

  closeModal = (modalName: 'showConfirmDeleteModal' | 'showCreateModal') => this.setState({ [modalName]: false, selectedCpt4: undefined })


  render() {
    const { mostActiveCpt4, mostActiveCpt4TotalPages, cpt4CodesOptions, serviceAreasOptions } = this.props
    const { selectedCpt4 } = this.state
    const pages: Array<number | any[]> = []
    // @ts-ignore
    for (let a = mostActiveCpt4TotalPages - 1; a > -1; a--) {
      pages.unshift(a)
    }
    const menuOptions: MenuOption[] = [
      {
        text: 'Edit',
        onClick: (id: number) => {
          if (id) {
            this.setState({ selectedCpt4: this.state.filtered.find(cpt4 => cpt4.id === id) })
            this.openModal('showCreateModal')
          }
        }
      },
      {
        text: 'Delete',
        variant: 'text-danger',
        onClick: (id: number) => {
          if (id) {
            this.setState({ selectedCpt4: this.state.filtered.find(cpt4 => cpt4.id === id) })
            this.openModal('showConfirmDeleteModal')
          }
        }
      }
    ]
    const actionBlock = (id: string) => {
      return (
        <DropMenu target={<DotsButton />}>
          <DropdownList menuOptions={menuOptions} id={id} />
        </DropMenu>
      )
    }
    const getActionsBlock = (id: any) => {
      return actionBlock(id)
    }

    const getTableBody = (patientsList: any[]) => {
      const { filtered = [] } = this.state
      const mainList = filtered
      return mainList.map((row: any, index: number) => ({
        id: row.id,
        columns: [
          row.cpt4Code,
          row.cpt4Description,
          row.contractGroup,
          row.serviceAreaId || 'Example',
          row.serviceAreaDescription || 'Example',
          //row.manual 
          index % 2 == 0
          ? <CheckCircleIcon/> : <CrossCircleIcon/>,
        ]
      }))
    }
    console.log(mostActiveCpt4, this.state.filtered);
    return (
      <WrapBlock>
        <HeadTitle>
          <Title>Most Active CPT4</Title>
          <RightHeadTitle>
            <Button variant={'default'} onClick={() => this.openModal('showCreateModal')}>
                Add new CPT4
            </Button>
            <Search
              onSearch={this.onSearch}
              onHandleClear={this.onHandleClear}
            />
          </RightHeadTitle>
        </HeadTitle>
        {mostActiveCpt4.length === 0 || this.state.filtered.length === 0 ? (
          <ContentBlock isCentered={true}>{this.noItems()}</ContentBlock>
        ) : (
          <>
            <Table
              header={headers}
              body={getTableBody(mostActiveCpt4)}
              actionBlock={getActionsBlock}
            />
            {mostActiveCpt4TotalPages !== 0 && (
              <Pagination onPageChanged={this.onPageChanged} allPages={pages} />
            )}
          </>
        )}
        <Modal
          modal={{
            title: 'Delete CPT4',
            content: (
              <Container>
                  Are you sure want to delete this CPT4?
              </Container>
            ),
            footer: (
              <Fragment>
                <Button variant={'text-danger'} onClick={this.handleDelete}>
                  Delete
                </Button>
                <Button variant={'text'} onClick={() => this.closeModal('showConfirmDeleteModal')}>
                  Cancel
                </Button>
              </Fragment>
            )
          }}
          isOpen={this.state.showConfirmDeleteModal}
        />
        <Modal
          modal={{
            title: selectedCpt4 ? 'Edit CPT4' : 'Add new CPT4',
            content: (
                <MostActiveCPT4Form 
                onSubmit={this.handleFormSubmit} 
                onClose={() => this.closeModal('showCreateModal')}
                cpt4Codes={cpt4CodesOptions}
                serviceAreas={serviceAreasOptions}
                // cpt4ToEdit={selectedCpt4} 
                />
            ),
          }}
          isOpen={this.state.showCreateModal}
        />
      </WrapBlock>
    )
  }
}

// tslint:disable-next-line:no-empty-interface
interface ReceivedProps {}
// interface MostActiveCpt4List {
//     id: number;
//     cpt4Code: string;
//     description: string;
//     contractGroup: string;
//     serviceAreaId: number;
//     serviceAreaDescription: string;
//     manual: boolean;
//     // createdAt: string;
// }
type StateProps = ReturnType<typeof mapStateToProps>
type DispatchProps = ReturnType<typeof mapDispatchToProps>
interface MostActiveCPT4PageState {
  filtered: MostActiveCpt4[]
  actualPage: number
  actualPages: number[]
  chunks: any
  pageNumbers: any
  searchText: string
  showConfirmDeleteModal: boolean;
  showCreateModal: boolean;
  selectedCpt4?: MostActiveCpt4;
  // For comfort and reusability
  [key: string]: any;
}
type Props = StateProps & DispatchProps & ReceivedProps

const mapStateToProps = (state: AppState) => { console.log(state); return ({
    mostActiveCpt4: state.mostActiveCpt4.data.content,
    mostActiveCpt4TotalPages: state.mostActiveCpt4.data.totalPages
    ? state.mostActiveCpt4.data.totalPages
    : 0,
    loadedPageNumber: state.mostActiveCpt4.data.number ? state.mostActiveCpt4.data.number : 0,
    cpt4CodesOptions: state.references.cpt4Codes.data.content.map(item => ({
        value: item.id,
        label: item.cpt4Code + ' - ' + item.description
    })),
    serviceAreasOptions: state.references.serviceAreas.data.content.map(item => ({ value: item.id, label: item.hsCode })),
    errors: state.references.cpt4Codes.errors
})}

const mapDispatchToProps = (dispatch: Dispatch) =>
  bindActionCreators(
    {
      fetchServiceAreas,
      fetchAllCpt4Codes,
      fetchMostActiveCpt4,
      createMostActiveCpt4,
      updateMostActiveCpt4,
      deleteMostActiveCpt4
    },
    dispatch
  )

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(MostActiveCPT4Page)

const WrapBlock = styled.div``

const Title = styled.h1`
  font-size: 30px;
  font-weight: 600;
  color: #152735;
  text-align: center;
  padding: 0;
`

const HeadTitle = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 2.5rem;
`

const TextBlock = styled.div`
  display: flex;
  flex-direction: column;

  p {
    color: #152735;
    margin-bottom: 1.5rem;
  }
`
const RightHeadTitle = styled.div`
  display: flex;
  flex-direction: row;

  > a,
  > button {
    margin-right: 30px;
    min-width: auto;
  }
`
